import React from 'react';
import type { Plant } from '../../../types/plant';
import { Bug, AlertCircle } from 'lucide-react';

interface MaintenanceCareProps {
  plant: Plant;
}

export default function MaintenanceCare({ plant }: MaintenanceCareProps) {
  return (
    <section id="maintenance-care">
      <h2 className="text-2xl font-semibold mb-6">Maintenance & Care</h2>

      <div className="space-y-6">
        {/* Common Pests */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center gap-2 mb-4">
            <Bug className="h-5 w-5 text-primary-500" />
            <h3 className="font-semibold">Common Pests</h3>
          </div>
          {plant.pests?.length > 0 ? (
            <div className="space-y-4">
              {plant.pests.map((pest) => (
                <div key={pest.id} className="border-b pb-4 last:border-0 last:pb-0">
                  <h4 className="font-medium mb-2">{pest.name}</h4>
                  <p className="text-gray-600 text-sm mb-2">{pest.description}</p>
                  {pest.solution && (
                    <div>
                      <p className="text-sm font-medium text-gray-700">Solution:</p>
                      <p className="text-sm text-gray-600">{pest.solution}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600">No common pest issues reported for this plant.</p>
          )}
        </div>

        {/* Common Diseases */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center gap-2 mb-4">
            <AlertCircle className="h-5 w-5 text-primary-500" />
            <h3 className="font-semibold">Common Diseases</h3>
          </div>
          {plant.diseases?.length > 0 ? (
            <div className="space-y-4">
              {plant.diseases.map((disease) => (
                <div key={disease.id} className="border-b pb-4 last:border-0 last:pb-0">
                  <h4 className="font-medium mb-2">{disease.name}</h4>
                  <p className="text-gray-600 text-sm mb-2">{disease.description}</p>
                  {disease.solution && (
                    <div>
                      <p className="text-sm font-medium text-gray-700">Solution:</p>
                      <p className="text-sm text-gray-600">{disease.solution}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600">No common diseases reported for this plant.</p>
          )}
        </div>
      </div>
    </section>
  );
}